import { GlAvatar, GlBadge, GlButton, GlIcon, GlLink, GlSprintf, GlTooltipDirective, GlTruncate } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, n__, sprintf } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { formatDate, getTimeago } from '~/lib/utils/datetime_utility';
import { toNounSeriesText } from '~/lib/utils/grammar';
import { cleanLeadingSeparator } from '~/lib/utils/url_utility';
import { truncate } from '~/lib/utils/text_utility';
import Markdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/non_gfm_markdown.vue?vue3';
import TopicBadges from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/topic_badges.vue?vue3';
import { CI_RESOURCE_DETAILS_PAGE_NAME } from '../../router/constants';
import { VERIFICATION_LEVEL_UNVERIFIED, VISIBILITY_LEVEL_PRIVATE } from '../../constants';
import CiVerificationBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/shared/ci_verification_badge.vue?vue3';
import ProjectVisibilityIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/shared/project_visibility_icon.vue?vue3';
export default {
    name: 'CiResourcesListItem',
    i18n: {
        components: s__('CiCatalog|Components:'),
        lastRelease: s__('CiCatalog|Released %{date}'),
        lastReleaseMissing: s__('CiCatalog|No release available'),
        publishedMessage: s__('CiCatalog|Published %{timeAgo} by %{author}'),
        publishedMessageNoAuthor: s__('CiCatalog|Published %{timeAgo}'),
        unreleased: s__('CiCatalog|Unreleased')
    },
    descriptionTruncateWidth: 260,
    components: {
        CiVerificationBadge,
        GlAvatar,
        GlBadge,
        GlButton,
        GlIcon,
        GlLink,
        GlSprintf,
        GlTruncate,
        Markdown,
        ProjectVisibilityIcon,
        TopicBadges
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        resource: {
            type: Object,
            required: true
        },
        showStats: {
            type: Boolean,
            required: false,
            default: true
        },
        showAuthor: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        authorName () {
            return this.latestVersion.author.name;
        },
        authorUsername () {
            return this.latestVersion.author.username;
        },
        authorId () {
            return getIdFromGraphQLId(this.latestVersion.author.id);
        },
        authorProfileUrl () {
            return this.latestVersion.author.webPath;
        },
        components () {
            return this.resource?.versions?.nodes[0]?.components?.nodes || [];
        },
        componentNamesSprintfMessage () {
            return toNounSeriesText(this.components.map((name, index)=>`%{componentStart}${index}%{componentEnd}`), {
                onlyCommas: true
            });
        },
        detailsPageHref () {
            return decodeURIComponent(this.detailsPageResolved.href);
        },
        detailsPageResolved () {
            return this.$router.resolve({
                name: CI_RESOURCE_DETAILS_PAGE_NAME,
                params: {
                    id: this.resourceId
                }
            });
        },
        entityId () {
            return getIdFromGraphQLId(this.resource.id);
        },
        formattedDate () {
            return formatDate(this.latestVersion?.releasedAt);
        },
        hasComponents () {
            return Boolean(this.components?.length);
        },
        hasReleasedVersion () {
            return Boolean(this.latestVersion?.releasedAt);
        },
        hasTopics () {
            return this.resource?.topics?.length;
        },
        isPrivate () {
            return this.resource?.visibilityLevel === VISIBILITY_LEVEL_PRIVATE;
        },
        isVerified () {
            return this.resource?.verificationLevel !== VERIFICATION_LEVEL_UNVERIFIED;
        },
        lastReleaseText () {
            if (this.latestVersion?.releasedAt) {
                const date = formatDate(this.latestVersion.releasedAt);
                return sprintf(this.$options.i18n.lastRelease, {
                    date
                });
            }
            return this.$options.i18n.lastReleaseMissing;
        },
        latestVersion () {
            return this.resource?.versions?.nodes[0] || [];
        },
        publishedMessageText () {
            return this.showAuthor ? this.$options.i18n.publishedMessage : this.$options.i18n.publishedMessageNoAuthor;
        },
        name () {
            return this.latestVersion?.name || this.$options.i18n.unreleased;
        },
        releasedAt () {
            return getTimeago().format(this.latestVersion?.releasedAt);
        },
        resourceId () {
            return this.resource?.fullPath;
        },
        starCount () {
            return this.resource?.starCount || 0;
        },
        starCountText () {
            return n__('Star', 'Stars', this.starCount);
        },
        usageCount () {
            return this.resource?.last30DayUsageCount || 0;
        },
        usageText () {
            return s__('CiCatalog|Number of unique projects that used a component from this catalog project in their pipelines in the last 30 days.');
        },
        webPath () {
            return cleanLeadingSeparator(this.resource?.webPath);
        },
        starsHref () {
            return this.resource.starrersPath;
        },
        truncatedDescription () {
            return truncate(this.resource.description, this.$options.descriptionTruncateWidth);
        },
        isArchived () {
            return Boolean(this.resource.archived);
        }
    },
    methods: {
        getComponent (index) {
            return this.components[Number(index)];
        },
        navigateToDetailsPage (e) {
            // Open link in a new tab if any of these modifier key is held down.
            if (e?.ctrlKey || e?.metaKey) {
                return;
            }
            // Override the <a> tag if no modifier key is held down to use Vue router and not
            // open a new tab.
            e.preventDefault();
            // Push to the decoded URL to avoid all the / being encoded
            this.$router.push({
                path: decodeURIComponent(this.resourceId)
            });
        }
    }
};
